import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Button, Box, Container, Stack } from '@mui/material';
import { AuthContext } from './AuthContext';
import LoginModal from './LoginModal';
import { fetchPlaceData } from './api.js';
import { useNotification } from './NotificationContext';
import SpinPongLogo from '../spin_pong_logo_bez_fona_SVG.svg';
import { useHookState } from './NotificationApiHook';
import { useNavigate } from 'react-router-dom';
import { PlaceContext } from '../contexts/PlaceContext';

function Header() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [token, setToken] = useState('');
  const [placeName, setPlaceName] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Добавляем состояние для отслеживания авторизации
  const authContext = useContext(AuthContext);
  const { openNotification } = useNotification();
  const { notificationState } = useHookState();
  const navigate = useNavigate();
  const { placeId } = useContext(PlaceContext);
  const isAdmin = localStorage.getItem('role_id') === '1';

  useEffect(() => {
    // Загрузка токена из локального хранилища при инициализации компонента
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    if (placeId) {
      fetchPlaceData(notificationState, placeId).then((data) => {
        setPlaceName(data[0].name);
      });
    }
  }, [placeId]);

  const handleLoginOpen = () => {
    setLoginOpen(true);
  };

  const handleLoginClose = () => {
    setLoginOpen(false);
  };

  // Обработчик для входа пользователя
  const handleLogin = async (data) => {
    try {
      const response = await fetch('https://acpong.llntnino.ru/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const responseData = await response.json();
        const token = responseData.access_token;
        const user_id = responseData.id;
        const role_id = responseData.role_id;
        localStorage.setItem('token', token); // Сохраняем токен в локальное хранилище
        localStorage.setItem('user_id', user_id); // Сохраняем токен в локальное хранилище
        localStorage.setItem('role_id', role_id); // Сохраняем айди роли в локальное хранилище
        setToken(token);
        fetchProfileData(token);
        setIsLoggedIn(true);
        authContext.updateLoggedInStatus();
        openNotification('Выполнен вход!', 'success');
        handleLoginClose();
      } else {
        openNotification('Ошибка входа! Проверьте вводимые данные', 'error');
        console.log('Ошибка при входе');
      }
    } catch (error) {
      openNotification(`Произошла ошибка при выполении запроса к серверу ${error}`, 'error');
      console.error('Ошибка при выполнении запроса:', error);
    }
  };

  const fetchProfileData = async (token) => {
    try {
      const response = await fetch('https://acpong.llntnino.ru/profile', {
        method: 'GET',
        headers: {
          Authorization: `JWT ${token}`,
        },
      });

      if (response.ok) {
        const profileData = await response.json();
        console.log('Профиль пользователя:', profileData);
        // Здесь вы можете сохранить полученные данные профиля в состояние компонента
      } else {
        openNotification('Произошла ошибка при получении данных профиля', 'error');
        console.log('Ошибка при получении профиля пользователя');
      }
    } catch (error) {
      openNotification(`Произошла ошибка при выполении запроса к серверу ${error}`, 'error');
      console.error('Ошибка при выполнении запроса:', error);
    }
  };
  const handleLogout = () => {
    setToken('');
    setIsLoggedIn(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role_id');
    authContext.updateLoggedInStatus();
    openNotification('Выход выполнен!', 'success');
  };

  return (
    <AppBar position='static'>
      <Container>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box
            to='/booking'
            component={Link}
          >
            <img
              src={SpinPongLogo}
              alt='Spin Pong Logo'
              style={{ width: '6rem', height: '4rem', marginTop: '10px' }}
            />
          </Box>
          <Stack direction='row'>
            {!placeName ? (
              <Button
                onClick={() => {
                  navigate('/pick-place');
                }}
                color='inherit'
              >
                Выбор зала
              </Button>
            ) : (
              <Button
                onClick={() => {
                  navigate('/pick-place');
                }}
                color='inherit'
              >
                {placeName}
              </Button>
            )}
            {isAdmin && (
              <Button
                onClick={() => {
                  navigate('/admin-panel');
                }}
                color='success'
                variant='contained'
              >
                Админка
              </Button>
            )}
          </Stack>
          {!isLoggedIn && (
            <Button
              onClick={handleLoginOpen}
              color='inherit'
            >
              Войти
            </Button>
          )}
          {isLoggedIn && (
            <Button
              onClick={handleLogout}
              color='inherit'
            >
              Выйти
            </Button>
          )}
          <LoginModal
            open={loginOpen}
            onClose={handleLoginClose}
            handleLogin={handleLogin}
          />
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
